import {
  type CustomerResource,
  isAudioResource,
  isDocumentResource,
  isImageResource,
  isUrlResource,
  isVideoResource,
} from 'src/data/performance';
import { createStateSelectorHook } from 'src/lib/sweetState';
// @ts-expect-error - ResourceStore does not have types
import { ResourceStore } from 'src/store/resource';

const useResourceState = createStateSelectorHook(ResourceStore, [
  'workspaceResources',
  'loadingResources',
  'resourcesFetched',
]);

export const useResources = (): {
  resources: CustomerResource[];
  loadingResources: boolean;
  resourcesFetched: boolean;
} => {
  const { workspaceResources, loadingResources, resourcesFetched } = useResourceState();

  return {
    resources: workspaceResources,
    loadingResources,
    resourcesFetched,
  };
};

export const useUrlResources = (): CustomerResource[] => {
  const { resources } = useResources();

  return (resources || []).filter(isUrlResource);
};

export const useImageResources = (): CustomerResource[] => {
  const { resources } = useResources();

  return (resources || []).filter(isImageResource);
};

export const useDocumentResources = (): CustomerResource[] => {
  const { resources } = useResources();

  return (resources || []).filter(isDocumentResource);
};

export const useDocumentAndUrlResources = (): CustomerResource[] => {
  const { resources } = useResources();

  return (resources || []).filter(
    (resource: CustomerResource) => isDocumentResource(resource) || isUrlResource(resource)
  );
};

export const useAudioResources = (): CustomerResource[] => {
  const { resources } = useResources();

  return (resources || []).filter(isAudioResource);
};

export const useVideoResources = (): CustomerResource[] => {
  const { resources } = useResources();

  return (resources || []).filter(isVideoResource);
};
